import { MangopaySDK } from '@contexts/deviceIntelligence/mangopay/mangopay';

export const loadMangopaySdk = async (): Promise<MangopaySDK> => {
    return new Promise<MangopaySDK>((resolve, reject) => {
        const SCRIPT_ID = 'mangopay-jssdk';
        const SDK_URL = 'https://dhw24ooi9auxf.cloudfront.net/s/987170/dGmThS.js';

        // Check if the SDK is already loaded and initialized
        if (window.dftp && typeof window.dftp.init === 'function') {
            resolve(window.dftp);
            return;
        }

        // Check if the script is already in the DOM
        let script = document.getElementById(SCRIPT_ID) as HTMLScriptElement;
        if (!script) {
            // Create and append the script element
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = SDK_URL;
            script.async = true;
            script.defer = true;
            script.id = SCRIPT_ID;

            document.body.appendChild(script);
        }

        const waitingMangopayReady = setInterval(() => {
            if (window.dftp && typeof window.dftp.init === 'function') {
                clearInterval(waitingMangopayReady);
                resolve(window.dftp); // Resolve when SDK is ready
            }
        }, 100); // Check every 100ms

        // Timeout after 20 seconds
        setTimeout(() => {
            clearInterval(waitingMangopayReady);
            reject(new Error('Mangopay SDK initialization timed out'));
        }, 20000);
    });
};
